export default __webpack_public_path__ + "static/media/adidas-W.b0f28189.png";